<template>
    <li class="flex items-start gap-3">
        <CheckIcon class="mt-1 h-5 w-5 shrink-0 text-blue" />
        <div>
            <p class="font-medium text-slate-900">{{ title }}</p>
            <p class="text-sm text-slate-600">{{ desc }}</p>
        </div>
    </li>
</template>

<script>
import CheckIcon from './CheckIcon.vue';

export default {
    name: 'FeatureItem',
    components: { CheckIcon },
    props: {
        title: { type: String, required: true },
        desc: { type: String, required: true }
    }
};
</script>
